import PROJECTS from './projects';
import JOBS from './jobs';
import FREELANCERS from './freelancers';
import REVIEWS from './reviews';
import NOTIFICATIONS from './notifications';
import SUBSCRIPTIONS from './subscriptions';
import FAVORITES from './favorites';
import BUSINESSES from './businesses';
import LEADS from './leads';
import SERVICES from './services';
import EXPERIENCE from './experience';
import CHAT from './chat';
import MESSAGING from './messaging';
import ADMIN from './admin';
import SETTINGS from './settings';


const API_ENDPOINTS = {
  BUSINESSES,
  PROJECTS,
  JOBS,
  FREELANCERS,
  REVIEWS,
  NOTIFICATIONS,
  SUBSCRIPTIONS,
  FAVORITES,
  LEADS,
  SERVICES,
  EXPERIENCE,
  CHAT,
  MESSAGING,
  ADMIN,
  SETTINGS
};

export default API_ENDPOINTS;